<template>
  <div id="crumbs">
    <a :style="btnStyles" href="javascript:void(0);"
      ><span @click="$emit('regular')">{{ text }} {{ kFormatter(stats) }}</span>
      <!--      <div-->
      <!--        title="Coming Calls"-->
      <!--        @click="$emit('coming')"-->
      <!--        :style="btnCommingStyles"-->
      <!--        class="dot-left"-->
      <!--      >-->
      <!--        {{ leftEar }}-->
      <!--      </div>-->
      <!--      <div-->
      <!--        title="Missed Calls"-->
      <!--        @click="$emit('missed')"-->
      <!--        :style="btnMissedStyles"-->
      <!--        class="dot-right"-->
      <!--      >-->
      <!--        {{ rightEar }}-->
      <!--      </div>-->
      <!--      <div-->
      <!--        title="Today Calls"-->
      <!--        @click="$emit('today')"-->
      <!--        :style="btnTodayStyles"-->
      <!--        class="dot-bottom-left"-->
      <!--      >-->
      <!--        {{ todayEar }}-->
      <!--      </div>-->
    </a>
  </div>
</template>

<script>
export default {
  name: "BreadcrumbButton",
  props: {
    variant: {
      type: String,
      required: false
    },
    bgColor: {
      type: String,
      required: true
    },
    txtColor: {
      type: String,
      required: true
    },
    text: {
      type: String,
      required: true
    },
    disabled: {
      type: Boolean,
      required: false
    },

    disabledMissed: {
      type: Boolean,
      required: false
    },

    disabledComming: {
      type: Boolean,
      required: false
    },
    disabledToday: {
      type: Boolean,
      required: false
    },
    stats: {
      type: Number,
      required: false
    },
    statsOverall: {
      type: Array,
      required: false
    },
    showOverall: {
      type: Boolean,
      required: false
    },
    earRight: {
      type: Boolean,
      required: false,
      default: false
    },
    earLeft: {
      type: Boolean,
      required: false,
      default: false
    },
    switchPlaces: {
      type: Boolean,
      required: false,
      default: false
    },
    leftEar: {
      type: Number,
      required: false
    },
    rightEar: {
      type: Number,
      required: false
    },
    todayEar: {
      type: Number,
      required: false
    }
  },
  data() {
    return {
      showPopup: false,
      yellow: "#fbc02d",
      red: "#ba000d",
      lightRed: "#af4448",
      grey: "#546e7a",
      main: "#fa8100",
      intervals: []
    };
  },

  computed: {
    btnStyles() {
      return {
        "--bg-color": this.disabled ? "#546e7a" : this.bgColor,
        "--hover-on-disable": this.disabled ? "-3px" : "0px",
        "--font-weight": this.disabled ? "bold" : "normal",
        "--txt-color": this.txtColor,
        "--border-color": this.variant === "outlined" ? "#546e7a" : this.bgColor
      };
    },
    btnMissedStyles() {
      return {
        "--missed-bg-color": this.disabledMissed ? this.grey : this.red,
        "--hover-on-disable": this.disabledMissed ? "-3px" : "0px",
        "--font-weight": this.disabledMissed ? "bold" : "normal",
        "--txt-color": this.txtColor,
        "--border-color": this.variant === "outlined" ? "#546e7a" : this.bgColor
      };
    },

    btnCommingStyles() {
      return {
        "--coming-bg-color": this.disabledComming ? this.grey : this.yellow,
        "--hover-on-disable": this.disabledComming ? "-3px" : "0px",
        "--font-weight": this.disabledComming ? "bold" : "normal",
        "--txt-color": this.txtColor,
        "--border-color": this.variant === "outlined" ? "#546e7a" : this.bgColor
      };
    },
    btnTodayStyles() {
      return {
        "--today-bg-color": this.disabledToday ? this.grey : this.main,
        "--hover-on-disable": this.disabledToday ? "-3px" : "0px",
        "--font-weight": this.disabledToday ? "bold" : "normal",
        "--txt-color": this.txtColor,
        "--border-color": this.variant === "outlined" ? "#546e7a" : this.bgColor
      };
    }
  },
  watch: {
    rightEar: function() {
      if (this.rightEar > 0) {
        this.intervals.push(
          setInterval(() => {
            const yellow = "#fbc02d";
            const red = "#c62828";
            const grey = "#546e7a";
            this.red = grey;
            let that = this;
            setTimeout(function() {
              that.red = red;
            }, 1500);
          }, 3000)
        );
      }
      if (this.rightEar < 1) {
        for (let i = 0; i < this.intervals.length; i++) {
          clearInterval(this.intervals[i]);
        }
        this.intervals = [];
      }
    },
    leftEar: function() {
      if (this.leftEar > 0) {
        this.intervals.push(
          setInterval(() => {
            const yellow = "#fbc02d";
            const red = "#c62828";
            const grey = "#546e7a";
            this.yellow = grey;
            let that = this;
            setTimeout(function() {
              that.yellow = yellow;
            }, 1500);
          }, 3000)
        );
      }
      if (this.leftEar < 1) {
        for (let i = 0; i < this.intervals.length; i++) {
          clearInterval(this.intervals[i]);
        }
        this.intervals = [];
      }
    }
  },
  methods: {
    /*      sumOveral(){
       // return this.statsOverall.map(item => item)
      // return this.statsOverall.map.reduce((a, b) => a + b, 0)
     return  this.statsOverall.reduce((a, b) => ({ov_count: a.ov_count + b.ov_count}));

        //this.statsOverall.reduce(function (a, b) {
     //     return {bod_count: a.bod_count + b.bod_count}; // returns object with property x
      //  })
      },
    sumOveral2(){
      // return this.statsOverall.map(item => item)
      // return this.statsOverall.map.reduce((a, b) => a + b, 0)
      return  this.statsOverall.reduce((a, b) => ({ov_count_2: a.ov_count_2 + b.ov_count_2}));

      //this.statsOverall.reduce(function (a, b) {
      //     return {bod_count: a.bod_count + b.bod_count}; // returns object with property x
      //  })
    },*/
    kFormatter: function(num) {
      if (num) {
        return Math.abs(num) > 999
          ? Math.sign(num) * (Math.abs(num) / 1000).toFixed(1) + "k"
          : Math.sign(num) * Math.abs(num);
      }
    }
  }
};
</script>

<style lang="scss" scoped>
$color: var(--bg-color);
$missedColor: var(--missed-bg-color);
$comingColor: var(--coming-bg-color);
$autoMissedColor: var(--auto-missed-bg-color);
$todayColor: var(--today-bg-color);
$borderColor: var(--border-color);
$hoverColor: #546e7a;
$fontWeight: var(--font-weight);
/*.tag-wrapper {*/
/*  display: inline;*/
/*}*/
/*#crumbs {*/
/*  position: relative;*/
/*}*/
/*#crumbs a {
  position:absolute;
  display: block;
  float: left;
  height: 20px;
  width: 65px;//70px;
  line-height: 16pt;
  background: $color;
  padding: 0 3px 0 4px;
  border-color: $borderColor ;
  position: relative;
  margin: 0 20px 0 0;
  text-align: center;
  text-decoration: none;
  color: var(--txt-color);
  font-size:8pt; //9pt;
  font-family: "Segoe UI", Arial, sans-serif;
  font-weight: bold; !*$fontWeight;*!
  border-bottom-left-radius: 3px;
  border-top-left-radius: 3px;
  top: var(--hover-on-disable);
}

#crumbs a:after {
  content: "";
  border-top: 10px solid ;
  border-bottom: 10px solid transparent;
  border-left: 10px solid $color;
  position: absolute;
  right: -10px;
  top: 0;


}*/
#crumbs a {
  height: 20px;
  width: 60px;
  line-height: 16pt;
  background: $color;
  padding: 3px 5px 3px 5px;
  border-color: $borderColor;
  position: relative;
  /*margin: 0 20px 0 0;*/
  text-decoration: none;
  color: var(--txt-color);
  font-size: 13px; //9pt;
  font-family: Montserrat;
  font-weight: bold; /*$fontWeight;*/
  border-bottom-left-radius: 5px;
  border-bottom-right-radius: 5px;
  border-top-left-radius: 5px;
  top: var(--hover-on-disable);
}

#crumbs a:hover {
  /* background: $hoverColor;
  top: -3px;*/
}
/*#crumbs a:hover::after {
  content: "";
  border-top: 10px solid transparent;
  border-bottom: 10px solid transparent;
  border-left: 10px solid $color;
  position: absolute;
  top: 0px;
  //top: 0;
}*/

.th-type #crumbs a {
  font-size: 10px;
}
</style>
